import { Pipe, PipeTransform } from "@angular/core";
import { Iso3166_1 } from "../../_model/Language";
import { countryAlpha2ToName } from "../../_utils/country-helper";


@Pipe({
	name: "isoCodeToCountryName",
	standalone: true
})
export class IsoCodeToCountryNamePipe implements PipeTransform {

	transform(isoCode: Iso3166_1 | null | "__"): string {
		if (!isoCode || isoCode === "__") return "";
		return countryAlpha2ToName(isoCode);
	}

}
